import { render, staticRenderFns } from "./Masthead.vue?vue&type=template&id=2ef5c590&scoped=true"
import script from "./Masthead.vue?vue&type=script&lang=js"
export * from "./Masthead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5c590",
  null
  
)

export default component.exports